import { useEffect, useState } from 'react';

import { DumpListSort, ExportFolder } from '../types';
import { dumpsListSorters } from '../sorting-schema';

export type QueryUrl = {
  defaultQuery: string | undefined;
  onUpdateUrl: (value: string) => void;
};

type UpdateStateHandler = (value: Partial<DumpsPageState>) => void;

interface DumpsPageState {
  dumps: ExportFolder[] | null;
  selectedGroup: ExportFolder | null;
}

function getSelectedGroup(
  dumps: ExportFolder[] | null,
  firstGroup: ExportFolder | null,
  previouslySelected: ExportFolder | null,
  queryGroupId?: string
): ExportFolder | null {
  if (queryGroupId && dumps) {
    return dumps.find((group) => group.id.toString() === queryGroupId) || null;
  }
  if (!previouslySelected && firstGroup) {
    return firstGroup;
  }

  return previouslySelected;
}

const useDumpsPageState = (dumps: ExportFolder[] | null, queryUrlParams: Record<string, any>) => {
  const [dumpsPageState, setdumpsPageState] = useState<DumpsPageState>({
    dumps: null,
    selectedGroup: null,
  });

  useEffect(() => {
    if (dumps) {
      const copydumps = [...dumps];
      const defaultSorteddumps = copydumps.sort(dumpsListSorters[queryUrlParams.sort as DumpListSort]);

      const firstGroup = defaultSorteddumps[0];
      setdumpsPageState((prevState) => ({
        dumps: defaultSorteddumps,
        selectedGroup: getSelectedGroup(defaultSorteddumps, firstGroup, prevState.selectedGroup, queryUrlParams.group),
      }));
    }
  }, [dumps]);

  const handleUpdatedumpsPageState: UpdateStateHandler = (newState) => {
    setdumpsPageState({ ...dumpsPageState, ...newState });
  };

  return {
    dumpsPageState,
    handleUpdatedumpsPageState,
  };
};

export { useDumpsPageState };
